import { useQuery } from 'react-query'

import { type OrderDraftPreferredCreationFlowEnum } from '@webapp/modules/purchasing/entities/enums/OrderDraftPreferredCreationFlowEnum'
import { orderDraftQueryConfig } from '../../../query-configs/orderDraft'

type UseQueryPreferredOrderRequestFlowReturn = {
  preferredOrderRequestFlow: OrderDraftPreferredCreationFlowEnum | undefined
  isFetching: boolean
}

export const useQueryPreferredOrderRequestFlow = (
  userId: number
): UseQueryPreferredOrderRequestFlowReturn => {
  const { data, isFetching } = useQuery({
    ...orderDraftQueryConfig.getPreferredRequestFlow(userId),
  })

  return {
    preferredOrderRequestFlow: data,
    isFetching,
  }
}
